import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  mobileNotification: {
    height: "64px",
    display: "flex",
    justifyContent: "space-between"
  },
  wrapper: {
    position: "sticky",
    top: 0,
    zIndex: 999,
    backgroundColor: "#3b3a3a"
  },
  paper: {
    fontSize: "16px",
    color: "#fff",
    lineHeight: "1.19",
    fontStyle: "normal",
    fontWeight: "normal",
    fontStretch: "normal",
    margin: 0,
    paddingTop: "12px",
    paddingBottom: "14px",
    paddingRight: "24px",
    paddingLeft: "16px"
  },
  closeIcon: {
    width: 24,
    right: 20,
    top: 20,
    cursor: "pointer"
  },
  closeIconWrapper: {
    padding: "20px 20px 0 0",
    alignItems: "flex-start"
  }
});
